module.exports = __webpack_public_path__ + "img/PackDefault.f1cc7c69.svg";